const DefaultToZero = function () {
  return 0
}

export default DefaultToZero
